/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingserviceMelcoDigitizingModelsOrderListItem
 */
export interface DigitizingserviceMelcoDigitizingModelsOrderListItem {
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderListItem
     */
    design_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderListItem
     */
    product_type_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderListItem
     */
    location_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderListItem
     */
    fabric_type_names?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderListItem
     */
    order_status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderListItem
     */
    client_name?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderListItem
     */
    created_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderListItem
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderListItem
     */
    is_payment_done?: boolean;
}

export function DigitizingserviceMelcoDigitizingModelsOrderListItemFromJSON(json: any): DigitizingserviceMelcoDigitizingModelsOrderListItem {
    return DigitizingserviceMelcoDigitizingModelsOrderListItemFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoDigitizingModelsOrderListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoDigitizingModelsOrderListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'design_name': !exists(json, 'design_name') ? undefined : json['design_name'],
        'product_type_name': !exists(json, 'product_type_name') ? undefined : json['product_type_name'],
        'location_name': !exists(json, 'location_name') ? undefined : json['location_name'],
        'fabric_type_names': !exists(json, 'fabric_type_names') ? undefined : json['fabric_type_names'],
        'order_status': !exists(json, 'order_status') ? undefined : json['order_status'],
        'client_name': !exists(json, 'client_name') ? undefined : json['client_name'],
        'created_date': !exists(json, 'created_date') ? undefined : (json['created_date'] === null ? null : new Date(json['created_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'is_payment_done': !exists(json, 'is_payment_done') ? undefined : json['is_payment_done'],
    };
}

export function DigitizingserviceMelcoDigitizingModelsOrderListItemToJSON(value?: DigitizingserviceMelcoDigitizingModelsOrderListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'design_name': value.design_name,
        'product_type_name': value.product_type_name,
        'location_name': value.location_name,
        'fabric_type_names': value.fabric_type_names,
        'order_status': value.order_status,
        'client_name': value.client_name,
        'created_date': value.created_date === undefined ? undefined : (value.created_date === null ? null : value.created_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'is_payment_done': value.is_payment_done,
    };
}


